import getCdnUrl from '@fingo/lib/helpers/get-cdn-url';

const FingoLogo = getCdnUrl('/logos/fingo-desktop@2x-80q.webp');

export default FingoLogo;
